module.exports = __webpack_public_path__ + "static/img/right-num-row-4.759926c7.png";